module.exports = __webpack_public_path__ + "images/days/day27.gif";